import Api from '@/services/Api'

export default {
  show (params) {
    return Api().post('deviceAlert', params)
  },
  showAll (params) {
    return Api().post('deviceAlertList', params)
  },
  showCareUserAlerts (params) {
    return Api().post('careUserAlertList', params)
  },
  state (params) {
    return Api().post('deviceAlertState', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/DeviceAlertService.js